module.exports = __webpack_public_path__ + "AgeIcon-c4344fd757ba8885b3dbc254fed46fce.svg";